import React from 'react';
import PropTypes from 'prop-types';
import styles from './FilterCard.module.css';

const FilterCard = ({ 
  title,
  children,
  className,
  ...props 
}) => {
  return (
    <div className={`${styles.filterCard} ${className || ''} filter-card`} {...props}>
      {title && (
        <div className={styles.filterHeader}>
          <h3 className={styles.filterTitle}>{title}</h3>
        </div>
      )}
      <div className={styles.filterBody}>
        {children}
      </div>
    </div>
  );
};

FilterCard.Row = ({ children, className, ...props }) => (
  <div className={`${styles.filterRow} ${className || ''}`} {...props}>
    {children}
  </div>
);

FilterCard.Col = ({ children, className, ...props }) => (
  <div className={`${styles.filterCol} ${className || ''}`} {...props}>
    {children}
  </div>
);

FilterCard.FormGroup = ({ label, children, className, ...props }) => (
  <div className={`${styles.formGroup} ${className || ''}`} {...props}>
    {label && <label className={styles.formLabel}>{label}</label>}
    {children}
  </div>
);

FilterCard.Select = ({ className, ...props }) => (
  <select className={`${styles.formSelect} ${className || ''}`} {...props} />
);

FilterCard.Input = ({ className, ...props }) => (
  <input className={`${styles.formInput} ${className || ''}`} {...props} />
);

FilterCard.SearchInput = ({ className, icon = 'fas fa-search', ...props }) => (
  <div className={styles.searchGroup}>
    <i className={`${icon} ${styles.searchIcon}`}></i>
    <input className={`${styles.searchInput} ${className || ''}`} {...props} />
  </div>
);

FilterCard.Button = ({ children, variant = 'outline', icon, onClick }) => {
  const buttonClass = `${styles.button} ${styles[`button${variant.charAt(0).toUpperCase()}${variant.slice(1)}`]}`;
  
  return (
    <button className={buttonClass} onClick={onClick}>
      {icon && <span className={styles.buttonIcon}>{icon}</span>}
      {children}
    </button>
  );
};

FilterCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

FilterCard.Row.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

FilterCard.Col.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

FilterCard.FormGroup.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

FilterCard.Select.propTypes = {
  className: PropTypes.string
};

FilterCard.Input.propTypes = {
  className: PropTypes.string
};

FilterCard.SearchInput.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string
};

FilterCard.Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'success', 'outline']),
  icon: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

export default FilterCard; 